var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / time / time-history"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33366 4.00002H3.40972C4.69676 2.5276 6.10647 2.00002 8.00033 2.00002C11.314 2.00002 14.0003 4.68631 14.0003 8.00002C14.0003 11.3137 11.314 14 8.00033 14C4.68662 14 2.00033 11.3137 2.00033 8.00002H0.666992C0.666992 12.0501 3.95024 15.3334 8.00033 15.3334C12.0504 15.3334 15.3337 12.0501 15.3337 8.00002C15.3337 3.94993 12.0504 0.666687 8.00033 0.666687C5.85808 0.666687 4.15838 1.27373 2.66699 2.83765V1.32749H1.33366V5.33335H5.33366V4.00002ZM11.3337 7.33335H8.66699V4.00002H7.33366V8.66669H11.3337V7.33335Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeHistory);
export default __webpack_public_path__ + "static/media/time-history.c5244b302286c0960d09de97c9d22f9d.svg";
export { ForwardRef as ReactComponent };